module.exports = __webpack_public_path__ + "img/success@3x.ea365dfa.png";